import { html } from "lit";
import { NavDivider } from "./nav-divider";

export const template = (props: NavDivider) => html`
  <div class="divider-container">
    <hr class="${props.expanded ? "divider-opened" : "divider-closed"}" />
  </div>
`;
